import { render, staticRenderFns } from "./BuildingsEquipTable.vue?vue&type=template&id=3b1c9cc4"
import script from "./BuildingsEquipTable.vue?vue&type=script&lang=js"
export * from "./BuildingsEquipTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports